// extracted by mini-css-extract-plugin
export default {"marginRight":"tab-item-module__marginRight--f8w6z"};